import { DestroyRef, Injectable, computed, inject, signal } from '@angular/core';

export const REDUCED_MOTION_MAX_LOOPS = 3;

@Injectable({ providedIn: 'root' })
export class ReducedMotionFacade {
  private readonly userSetting = signal(false);
  private readonly osPrefersReduce = signal(false);

  public readonly isActive = computed(() => this.userSetting() || this.osPrefersReduce());

  public constructor() {
    const mql = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.osPrefersReduce.set(mql.matches);

    const onChange = (event: MediaQueryListEvent) => this.osPrefersReduce.set(event.matches);
    mql.addEventListener('change', onChange);

    inject(DestroyRef).onDestroy(() => mql.removeEventListener('change', onChange));
  }

  public setUserSetting(enabled: boolean): void {
    this.userSetting.set(enabled);
  }
}
